import React from "react";
import PropTypes from "prop-types";

/**
 * Checkbox component for web
 *
 * Custom checkbox with label support
 */
const Checkbox = ({
  label,
  checked = false,
  onChange,
  disabled = false,
  indeterminate = false,
  error,
  className = "",
  id,
  name,
  description,
  ...props
}) => {
  // Generate ID - handle both string and JSX labels
  const checkboxId =
    id ||
    name ||
    `checkbox-${typeof label === "string" ? label.replace(/\s+/g, "-").toLowerCase() : Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className="flex flex-col">
      <div className="flex items-start">
        <div className="flex items-center h-5">
          <input
            type="checkbox"
            id={checkboxId}
            name={name}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            ref={(input) => {
              if (input) {
                input.indeterminate = indeterminate;
              }
            }}
            className={["checkbox", error && "border-error-500", className]
              .filter(Boolean)
              .join(" ")}
            aria-invalid={error ? "true" : "false"}
            aria-describedby={error ? `${checkboxId}-error` : undefined}
            {...props}
          />
        </div>
        <div className="flex-1">
          {label && (
            <label
              htmlFor={checkboxId}
              className={[
                "ml-2 text-sm font-medium select-none",
                disabled
                  ? "text-neutral-400 cursor-not-allowed"
                  : "text-neutral-700 cursor-pointer",
              ]
                .filter(Boolean)
                .join(" ")}
            >
              {label}
            </label>
          )}
          {description && (
            <p className="ml-2 mt-1 text-xs text-neutral-500">{description}</p>
          )}
        </div>
      </div>
      {error && (
        <p id={`${checkboxId}-error`} className="mt-1 text-sm text-error-600">
          {error}
        </p>
      )}
    </div>
  );
};

Checkbox.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  indeterminate: PropTypes.bool,
  error: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
};

export default Checkbox;
